import { Env } from './ApiManager';

export function getDefaultEnv() {
  // Check for Official Website (Static Site Build)
  if (typeof window === 'undefined') return null;

  const origin = window.location.origin;
  if (/https:\/\/(.+\.)*alfred\.camera/.test(origin)) {
    return Env.Prod;
  } else if (/https:\/\/wildlands\.my-alfred\.com/.test(origin)) {
    return Env.PreProd;
  } else {
    return Env.Dev;
  }
}

export function setupThrottle<T, P extends unknown[]>(func: (...args: P) => Promise<T>, delayMs = 50) {
  let isWaiting = false;
  return async (...args: P): Promise<T | undefined> => {
    if (isWaiting) {
      await new Promise((res, rej) => {
        const check = () => {
          try {
            if (!isWaiting) {
              return res(true);
            } else {
              setTimeout(check, delayMs);
            }
          } catch (err) {
            return rej(err);
          }
        };
        check();
      });
    } else {
      try {
        isWaiting = true;
        const data = await func(...args);
        isWaiting = false;
        return data;
      } catch (err) {
        isWaiting = false;
        throw err;
      }
    }
  }
}
